import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { of, Subject } from "rxjs";
import { ActivatedRoute } from "@angular/router";

import { SpinnerService } from "../../core/spinner/spinner.service";
import { environment } from "../../../environments/environment";
import { AuthService } from "../auth.service";
import { StoredUser } from "../../shared/models/stored-user";
import { VERSION } from "../../../environments/version";
import { switchMap, take, takeUntil } from "rxjs/operators";
import { AppWebSocketService } from "../../core/services/app-web-socket.service";
import { Settings } from "../../shared/models";
import { ConnectionStatus } from "../../shared/enums";
import { ManagerService } from "../../core/services/manager.service";
import { ConfigService } from "../../core/services/config.service";
import { WINDOW } from "../../core/services/window.providers";
import { RegistrationIframeDialogComponent } from "../registration-iframe-dialog/registration-iframe-dialog.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  username: string;
  password: string;
  token: string;
  referral: string;
  campaignId: string;
  settings: Settings;
  passwordVisible = false;

  environment = environment;
  appVersion = VERSION.current;
  loader = false;
  destroy$ = new Subject<boolean>();

  config;

  registrationUrl: string;

  constructor(
    @Inject(WINDOW) private window: Window,
    private _route: ActivatedRoute,
    private _spinnerService: SpinnerService,
    private _authService: AuthService,
    private _socketService: AppWebSocketService,
    private _managerService: ManagerService,
    private configService: ConfigService,
    private _dialog: MatDialog,
  ) {
    this.config = this.configService.config;
  }

  @HostListener("document:keydown", ["$event"]) onKeydownHandler(
    event: KeyboardEvent,
  ) {
    if (this._dialog.openDialogs.length > 0) {
      return;
    }
    if (event.key === "Enter") {
      this.login();
    }
  }

  openRegistrationModal(): void {
    if (!this.registrationUrl) {
      return;
    }
    this._dialog.open(RegistrationIframeDialogComponent, {
      data: { registrationUrl: this.registrationUrl },
      width: "min(960px, calc(100vw - 32px))",
      maxWidth: "96vw",
      height: "min(90vh, 880px)",
      maxHeight: "90vh",
      panelClass: "registration-iframe-dialog-panel",
      backdropClass: "registration-iframe-dialog-backdrop",
      autoFocus: false,
    });
  }

  ngOnInit() {
    this._spinnerService.show();

    this._socketService.connectionStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((connectionStatus: ConnectionStatus) => {
        if (connectionStatus === ConnectionStatus.close) {
          this._authService.wsConnect(); // ## In case that user previously logout
        }
      });

    this._managerService.loginState$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (loggedIn) => {
        if (!loggedIn) {
          this.loader = false;
        }
      },
    });

    this._managerService.settings$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (settings) => {
        if (settings) {
          this.settings = settings;
          this._spinnerService.hide();

          if (this.settings.RegistrationUrl) {
            const url = new URL(this.settings.RegistrationUrl);
            url.searchParams.set("retrunUrl", this.window.location.hostname);
            this.registrationUrl = url.toString();
          }
        }
      },
    });

    this._socketService.connectionStatus$
      .pipe(
        switchMap((connectionStatus) => {
          if (connectionStatus === ConnectionStatus.open) {
            return this._route.queryParams;
          } else {
            return of(null);
          }
        }),
        takeUntil(this.destroy$),
      )
      .subscribe((queryParams) => {
        const storedUser = JSON.parse(
          localStorage.getItem("auth-login"),
        ) as StoredUser;
        const exitUrl = queryParams ? queryParams["exitUrl"] : null;

        if (queryParams && queryParams["token"]) {
          this.token = queryParams["token"];
          this._managerService.login({ token: queryParams["token"] });
        } else if (exitUrl) {
          window.location.href = exitUrl;
        } else if (storedUser) {
          this.username = storedUser.username;
          this.password = storedUser.password;
          this._authService.shouldStoreUser = true;

          this._managerService.settings$
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                // auto login /remember me  this.login()
              },
            });
        }
      });

    this._route.queryParams.pipe(take(1)).subscribe((queryParams) => {
      if (queryParams && this.config.newLayout) {
        this.campaignId = queryParams["camp_id"];
        this.referral = queryParams["referral"];
      }

      if (
        (!queryParams || (queryParams && !queryParams["token"])) &&
        this.config.loginRedirect
      ) {
        window.open(`https://${this.config.loginForceRedirectUrl}`, "_self");
      }
    });
  }

  ngAfterViewInit() {
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      input.addEventListener(
        "focus",
        () => {
          setTimeout(() => {
            // mali trik - pomeri malo pa vrati da triggeruje reflow
            window.scrollTo(0, 1);
            window.scrollTo(0, 0);
          }, 300);
        },
        { once: true },
      ); // samo prvi put
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  login() {
    const username = this.username?.trimLeft()?.trimRight() ?? "";
    const password = this.password;

    if (!username || !password) {
      return;
    }

    this.loader = true;
    if (this.config.brand === "newWavePoker") {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: "login",
        affiliateid: this.referral,
        campid: this.campaignId,
      });
    }
    this._managerService.login({ username, password });
  }

  register() {
    this.openRegistrationModal();
  }

  rememberMe(status) {
    this._authService.shouldStoreUser = status;
  }
}
